
import { defineComponent, PropType } from "vue";
import { useRouter } from "vue-router/composables";
import { ROUTENAMES } from "@models/constants/routes";
import CiButton from "@components/base/button.vue";
import CiTag from "@components/tags/tag.vue";

export default defineComponent({
  name: "CiUsersProfileAdvisoryServices",
  components: { CiTag, CiButton },
  inject: {
    slug: "userSlug",
  },
  props: {
    items: {
      type: Array as PropType<UsersV2.AdvisoryServiceItem[]>,
      default: () => [],
    },
  },
  setup(props) {
    const router = useRouter();
    const joinedTags = () => props.items.map((item) => item.title).join(", ");

    const searchPath = (service: string) =>
      router.resolve({
        name: ROUTENAMES.ADVISOR_SEARCH_INDEX,
        params: { location: "-", service },
      }).href;

    return {
      joinedTags,
      searchPath,
    };
  },
});
